import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'seb-digital-usage-table',
  templateUrl: './digital-usage-table.component.html',
  styleUrls: ['./digital-usage-table.component.css']
})
export class DigitalUsageTableComponent implements OnInit {
  @Input() products: Array<any>;

  constructor() {}

  ngOnInit() {}

  getSplitedColors(unitedColors: string) {
    let splitedColors = unitedColors.split('#');
    return {
      tagBackgroundColor: `#${splitedColors[1]}`,
      tagTextColor: `#${splitedColors[2]}`
    };
  }
}
